<template>
    <div>
        <querytitle>
            <template slot="queryleft">
                <div>所属区域：</div>
                <div>
                    <el-checkbox v-model="chk"></el-checkbox>下级
                </div>
                <div>
                    <selecttreeview size="mini" v-model="unit" :multiple="false" width="100px" :list="units" :obj="props"></selecttreeview>
                    <!-- <el-cascader v-model="unit" :options="units" size="mini" :props="props">
                        <template slot-scope="{ node, data }">
                            <i :class="data.icon"></i>
                            <span>{{ data.unit_name }}</span>
                        </template>
                    </el-cascader> -->
                </div>
                <div>年度：</div>
                <div>
                    <el-select v-model="yy" size="mini" style="width:80px;">
                        <el-option v-for="(item) in yys" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </div>
                <div>单位等级：</div>
                <div>
                    <el-select v-model="this_level" size="mini" style="width:130px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item) in levels" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
                </div>
                <div>单位类型:</div>
                <div>
                    <el-select v-model="this_type" size="mini" style="width:130px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item) in types" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
                </div>
                <div>申报方式:</div>
                <div>
                    <el-select v-model="checktype" size="mini" style="width:80px;">
                        <el-option v-for="(item) in checktypes" :key="item.FID" :label="item.FVALUE"
                            :value="item.FID"></el-option>
                    </el-select>
                </div>
                <div>模糊条件：</div>
                <div><el-input size="mini" v-model="keyword" style="width:100px;"></el-input></div>
                <div>
                    <el-button type="primary" size="mini" @click="initdata()">查询</el-button>
                </div>
            </template>
        </querytitle>
        <el-table :data="itemlist" border style="width: 100%" :height="hh" stripe size="mini">
            <el-table-column prop="adv_name" label="单位名称"></el-table-column>
            <el-table-column prop="checktype" label="申报方式" width="70"></el-table-column>
            <el-table-column prop="this_level" label="单位等级" width="100"></el-table-column>
            <el-table-column prop="this_type" label="单位类型" width="100"></el-table-column>
            <el-table-column prop="adv_property" label="单位性质" width="70"></el-table-column>
            <el-table-column prop="pj_rate" label="评级" width="70"></el-table-column>
            <el-table-column prop="pjfs" label="总得分" width="90" sortable></el-table-column>
            <el-table-column prop="cs" label="已评" width="70" sortable></el-table-column>
            <el-table-column prop="pj_date" label="考核日期" width="110"></el-table-column>
            <el-table-column prop="newcs" label="新增" width="70" sortable>
                <template slot-scope="scope">
                    <div style="color:red;">{{scope.row.newcs}}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="260" align="center">
                <template slot-scope="scope">
                    <el-link type="success" icon="el-icon-finished" v-if="scope.row.pj" size="mini" @click="chkshow(scope)">单位评级</el-link>
                    <el-link :href="'api/pdfGenerateAdvApplyShow?c_id='+scope.row.c_id" target="_blank"
                        icon="el-icon-view" type="primary" size="mini">查看申报</el-link>                    
                    <el-link type="danger" icon="el-icon-finished" v-if="scope.row.pj" size="mini" @click="Cancel(scope)">撤销称号</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="text-align:left;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentpage" :page-sizes="[10, 20, 30, 40,500]" :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="rt">
        </el-pagination>
        <el-dialog title="单位评级" :visible.sync="dialogFormVisible" width="90%" class="abow_dialog" @closed="getlist()">
            <el-descriptions :columns="4" border>
                <el-descriptions-item :span="1">
                    <template slot="label">测评标准</template>
                    {{evatype.t_name}}
                </el-descriptions-item>
                <el-descriptions-item :span="1">
                    <template slot="label">测评单位</template>
                    {{itemedit.adv_name}}
                </el-descriptions-item>
                <el-descriptions-item :span="2">
                    <template slot="label">测评打分情况</template>
                    当前评级为：<span class="bold">{{pj.pj_rate}}</span>级<span class="bold">{{pj.pjfs}}</span>分
                    <el-button size="mini" type="danger" @click="dialogFormVisible3=true" style="float:right;">评级打分</el-button>
                </el-descriptions-item>
            </el-descriptions>
            <div style="text-align: center;">
            <el-table :data="rules" border stripe style="width:100%;margin-bottom: 20px;" :height="hh-15" default-expand-all :row-class-name="tableRowClassName"  size="mini" row-key="EVA_ID"  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column prop="EVA_OID" label="编号" width="70"></el-table-column>
                <el-table-column prop="EVA_NAME" label="测评项目"></el-table-column>
                <el-table-column prop="EVA_ENDDATE" label="截止日期" width="100"></el-table-column>
                <el-table-column prop="EVA_FS" label="分值" width="70" align="center"></el-table-column>
                <el-table-column prop="FS" label="已得分" width="70" align="center"></el-table-column> 
                <el-table-column prop="EVA_CS" label="最少次数" width="70" align="center"></el-table-column>
                <el-table-column prop="CS" label="已评" width="70" align="center"></el-table-column>
                <el-table-column prop="NEWCS" label="新增" width="70" align="center">
                    <template slot-scope="scope">
                        <span style="color:red;">{{scope.row.NEWCS}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="CHK" label="审核中" width="70" align="center"></el-table-column>
                <el-table-column label="操作" width="70">
                    <template slot-scope="scope">
                        <!-- <el-link size="mini" :href="'/api/newslistshow?eva_id='+scope.row.EVA_ID+'&adv_id='+itemedit.adv_id" target="_blank" type="success" icon="el-icon-view">查看</el-link> -->
                        <el-link size="mini" :type="scope.row.NEWCS>0?'danger':'success'" icon="el-icon-finished" @click="df(scope)" v-if="scope.row.EVA_LEVEL!='1'">打分</el-link>
                    </template>
                </el-table-column>
            </el-table>
            </div>
        </el-dialog>
        <el-dialog title="测评打分" :visible.sync="dialogFormVisible1" width="90%" top="25px" append-to-body v-dialogDrag>
           <querytitle>
                <template slot="queryleft">
                    <div>
                        <div>{{itemeva.EVA_NAME}}</div>
                        <div style="font-size:12px;color:#ccc;">{{itemeva.EVA_OTHER}}</div>
                    </div>
                </template>
                <template slot="queryright">
                    <el-button size="mini" type="danger" @click="dialogFormVisible2=true">打分</el-button>
                </template>
           </querytitle>
           <newslistshow v-if="dialogFormVisible1" :pars="{'adv_id':currentadv_id,'eva_id':currenteva_id}" :hh="hh+10" @refreshdataevent="getadvevafsbytree(itemedit)"></newslistshow>
           <!-- <iframe :src="'/api/newslistshow?eva_id='+itemeva.EVA_ID+'&adv_id='+itemedit.adv_id" :style="'width:100%;height:'+(hh+29)+'px;border:0px;'"></iframe> -->
        </el-dialog>
        <el-dialog title="测评项打分" :visible.sync="dialogFormVisible2" width="60%" top="30vh" append-to-body v-dialogDrag>
            <el-descriptions :column="3" border :labelStyle="{width:'120px'}">
                <el-descriptions-item :span="3">
                    <template slot="label">测评项目：</template>
                    {{itemeva.EVA_NAME}}
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">测评描述</template>
                    {{itemeva.EVA_OTHER}}
                </el-descriptions-item>
                <el-descriptions-item :span="2">
                    <template slot="label">此项分值：</template>
                    {{itemeva.EVA_FS}}
                </el-descriptions-item>
                <el-descriptions-item :span="1">
                    <template slot="label">此项得分</template>
                    <el-input-number :max="itemeva.EVA_FS" :min="-9999" v-model="itemeva.FS"></el-input-number>
                </el-descriptions-item>
            </el-descriptions>
            <div slot="footer" class="dialog-footer">        
                <el-button @click="dialogFormVisible2=false">取 消</el-button>
                <el-button type="primary" @click="dfsummit()">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="评级打分" :visible.sync="dialogFormVisible3" width="60%" top="30vh" append-to-body v-dialogDrag>
            <el-descriptions :column="3" border :labelStyle="{width:'120px'}">
                <el-descriptions-item :span="3">
                    <template slot="label">总得分：</template>
                    <el-input-number v-model="pj.pjfs"></el-input-number>
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">评级</template>
                    <el-input v-model="pj.pj_rate" style="width:100px;"></el-input> （例如：A、B、C、D）
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">评级意见</template>
                    <el-input type="textarea" :maxlength="100" v-model="pj.pj_opinion"></el-input>
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">评级人</template>
                    {{CU.cu.uname}}
                </el-descriptions-item>
            </el-descriptions>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible3=false">取 消</el-button>
                <el-button type="primary" @click="pjsummit()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style lang="less">
  .el-table .warning-row {
    background: #ebebeb;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  .bold{
    font-size: 15px;
    font-weight: bold;
    color: red;
  }
    .abow_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
            .el-dialog__footer{
                position: absolute;
                bottom: 0px;
                right: 0px;
                z-index: 999;
            }
        }
    }
</style>
<script>
import querytitle from "../../components/querytitle.vue";
import selecttreeview from "@/components/selecttreeview"
import Newslistshow from '@/components/newslistshow.vue';
export default {
  components: { querytitle,selecttreeview,Newslistshow },
  data(){
      return{
        yys:[],
        yy:'2022',
        itemlist:[],
        rt: 0,
        currentpage: 1,
        pagesize: 20,
        logs:[],
        hh:560,
        checktype:'',
        checktypes:[],
        this_level:'',        
        levels:[],
        this_type:'',
        types:[],
        keyword:'',
        dialogFormVisible:false,//单位评级明细展示
        itemedit:{},
        rules:[],
        evatype:{},
        dialogFormVisible1:false,//单位测评项材料展示
        itemeva:{},
        dialogFormVisible2:false,//单位测评项打分
        dialogFormVisible3:false,//单位评级
        pj:{},
        units:[],
        unit:'',
        chk:false,
        props:{id:'unit_id',label:'unit_name',children:'children',pid:'parent_unit'},
        currentadv_id:'',currenteva_id:'',
      }
  },
  created() {
      let that = this
      that.unit = that.CU.cu.orgid;
      that.hh = document.documentElement.clientHeight - 225;
      that.GETENUM('adv_check', 'checktype', true, function (res) {
          that.checktypes = res
          if (that.checktypes.length > 0) {
              that.checktype = that.checktypes[0].FID;
          }
      })
      that.GetDict('单位等级', function (res) {
          that.levels = res.data
      })
      that.GetDict('单位类型', function (res) {
          that.types = res.data
      })
      that.GetData('SYS/GetUnits', { orgtype: '文明办' }, function (res1) {
          that.units = res1.data.data
          //that.getlist();
      }, function (err) {
          that.$alert(err, { title: "错误" });
      })
      that.GetYears(function (res) {
          that.yys = res.data
          that.yy = res.yy
          that.getlist();
      });
  },
  methods:{
    initdata(){
        this.currentpage = 1
        this.pagesize = 20
        this.getlist();
    },
    getyears(){
        let that = this
        that.GetData("Years", {},function (res) {
          that.yys = res.data.data
          that.yy = res.data.yy
          that.getlist();
        },function (err) {
          that.$alert(err, {title: "错误"});
        }
      );
    },
    Cancel(par){//撤销称号
        let that = this
        that.$confirm('撤销称号后此单位将无法再登陆了！您确定要将【' + par.row.adv_name + '】撤销吗？', "询问", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            var pars = { objname: "adv_check", keyfield:"c_id",keyvalue:par.row.c_id,fields:{adv_state:'取消'}};
            that.PostData("Common/UPDATE", pars, function (res) {
                that.itemlist.splice(par.$index, 1);
            }, function (err) {
                that.$alert(err, { title: "错误", type: 'error' });
            }
            );
        })
            .catch(() => { });
    },
    tableRowClassName({row, rowIndex}) {
            if (row.EVA_LEVEL=== 1)
                return 'warning-row';
            else if (row.EVA_LEVEL === 2)
                return 'success-row';
            else
                return '';
        },
    getadvevafsbytree(item,callback){
        let that =this
        that.GetData('Flow/GetAdvEvaFSByTree',{advid:item.adv_id,yy:item.c_yy},function(res){
                that.evatype = res.data.et
                that.rules = res.data.data;
                that.pj = res.data.pj;
                if(callback)
                    callback();
            },function(err){
                that.$alert(err, { title: "错误", type: 'error' });
        })
    },
    chkshow(par){//单位评级项目展示
        let that = this
        this.addflag = false;
        this.itemindex = par.$index;
        this.itemedit = Object.assign({}, par.row);
        that.getadvevafsbytree(that.itemedit);  
        that.dialogFormVisible = true;      
    },

    df(par){//打分展示
        let that = this
        that.itemeva = par.row;
        that.currenteva_id =  that.itemeva.EVA_ID
        that.currentadv_id = that.itemedit.adv_id;
        that.dialogFormVisible1 = true;
    },
    dfsummit(){//打分提交
        let that = this
        let checkfs = {advid:that.itemedit.c_id,eva_id:that.itemeva.EVA_ID,fs:that.itemeva.FS}
        that.PostData('Flow/SetAdvEvaFS',checkfs,function(res){
            that.getadvevafsbytree(that.itemedit,function(){
                that.dialogFormVisible1 = false    
                that.dialogFormVisible2 = false    
            });            
        },function(err){
            that.$alert(err, { title: "错误", type: 'error' });
        })
    },
    pjsummit(){//评级提交
        let that = this
        let pj={c_id:that.itemedit.c_id,pj_rate:that.pj.pj_rate,pjfs:that.pj.pjfs,pj_opinion:that.pj.pj_opinion}
        that.PostData('Flow/SetAdvPJ',pj,function(res){
            that.dialogFormVisible =false;
            that.dialogFormVisible3 =false;
        },function(err){
            that.$alert(err, { title: "错误", type: 'error' });
        })
    },
    getlist(){
      const that = this
      let pars = {
        yy:that.yy,
        wheres:[],
        PageSize: that.pagesize,
        CurrentPage: that.currentpage,orders:[{field:'a.c_id',asc:'asc'}]}
      if(this.this_level)
        pars.wheres.push({field: 'a.this_level',sym: '=',val: this.this_level,oper: 'and'})
      if(this.this_type)
        pars.wheres.push({field: 'a.this_type',sym: '=',val: this.this_type,oper: 'and'})
      if(this.checktype)
        pars.wheres.push({field: 'a.checktype',sym: '=',val: this.checktype,oper: 'and'})
      if(this.keyword)
        pars.wheres.push({field:'a.adv_name',sym:'like',val:'%'+this.keyword+'%',oper:'and'})
      if(this.unit){
        if(this.chk)
          pars.wheres.push({field: 'd.parent_unit',sym: 'like',val: this.unit+'%',oper: 'and'})
        else
          pars.wheres.push({field: 'd.parent_unit',sym: '=',val: this.unit,oper: 'and'})
      }
      that.PostData('Flow/GetAdvFS', pars, res => {
        that.itemlist = res.data.data
        that.pjfq = res.data.pjfq
        that.rt = res.data.rowTotal
      }, err => {
        that.$alert(err, {title: "错误"});
      })
    },
    handleCurrentChange(e) {
      this.currentpage = e;
      this.getlist()
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.getlist()
    },
  }
};
</script>